import { css, setProps, styled } from "theme";

type SGroupImageProps = {
  isOpen: boolean;
  isArabic: boolean;
};

const isOpenSet = setProps<SGroupImageProps>(({ isOpen }) => isOpen)(css`
  transform: rotate(0deg);
`);

const isArabicLang = setProps<SGroupImageProps>(({ isArabic, isOpen }) => isArabic && !isOpen)(css`
  transform: rotate(90deg);
`);

export const SGroupImage = styled.div<SGroupImageProps>`
  transform: rotate(-90deg);

  ${isOpenSet};
  ${isArabicLang};
`;
